import { FC } from 'react';
import { Menu } from 'ui/menu/Menu';
import { MenuItemOption } from 'ui/menu/types';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { ALIGNMENT } from 'ui/menu/constants';
import { IconButton, BUTTON_VARIANTS } from 'ui/button';
import { isEmptyString } from 'utils/stringHelpers';
import {
  StyledDivider,
  MenuWrapper,
  AnalyticsCardWrapper,
  AnalyticsCardHeader,
  AnalyticsCardContent,
  StyledSkeletonContainer,
} from './Styled';
import { Error } from '../Error';

type AnalyticsCardType = {
  title?: string;
  height: string | number;
  loading: boolean;
  error: boolean;
  noPadding?: boolean;
  menuOptions?: MenuItemOption[];
  handleSelectionChange?: () => void;
  handleReload?: () => void;
};

export const AnalyticsCard: FC<React.PropsWithChildren<AnalyticsCardType>> = ({
  title,
  height,
  loading,
  error,
  noPadding = false,
  menuOptions,
  handleSelectionChange,
  handleReload,
  children,
}) => {
  return (
    <AnalyticsCardWrapper>
      {title && (
        <>
          <AnalyticsCardHeader>
            {title}
            <div>
              {menuOptions && (
                <MenuWrapper>
                  <Menu
                    handleSelectionChange={handleSelectionChange}
                    horizontalAlignment={ALIGNMENT.RIGHT}
                    options={menuOptions}
                  >
                    <IconButton variant={BUTTON_VARIANTS.SECONDARY}>
                      <Overflow />
                    </IconButton>
                  </Menu>
                </MenuWrapper>
              )}
            </div>
          </AnalyticsCardHeader>
          <StyledDivider />
        </>
      )}
      <StyledSkeletonContainer
        isLoading={loading && !error}
        height={height}
        borderTop={isEmptyString(title)}
      >
        {error ? (
          <Error handleReload={handleReload} />
        ) : (
          !loading && <AnalyticsCardContent noPadding={noPadding}>{children}</AnalyticsCardContent>
        )}
      </StyledSkeletonContainer>
    </AnalyticsCardWrapper>
  );
};
